import React, { useState } from 'react';
import { FiNavigation, FiInfo } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import Card from '../components/Common/Card';
import Input from '../components/Common/Input';
import Button from '../components/Common/Button';
import styles from './LiveStationPage.module.css';

const LiveStationPage: React.FC = () => {
  const navigate = useNavigate();
  const [stationCode, setStationCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!stationCode.trim()) {
      setError('Please enter a station code');
      return;
    }

    if (stationCode.length < 2) {
      setError('Station code must be at least 2 characters');
      return;
    }

    setIsLoading(true);
    navigate(`/live-station/${stationCode.toUpperCase()}`);
    setIsLoading(false);
  };

  const handleStationCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().slice(0, 10);
    setStationCode(value);
    if (error) setError('');
  };

  return (
    <div className={styles.liveStationPage}>
      <div className="container">
        {/* Header */}
        <div className={styles.header}>
          <h1 className={styles.title}>
            <FiNavigation className={styles.titleIcon} />
            Live at Station
          </h1>
          <p className={styles.subtitle}>
            Check all trains arriving and departing from any station in real-time
          </p>
        </div>

        {/* Form */}
        <Card className={styles.formCard}>
          <form onSubmit={handleSubmit} className={styles.form}>
            <Input
              type="text"
              value={stationCode}
              onChange={handleStationCodeChange}
              placeholder="Enter station code (e.g., NDLS, BCT, HWH)"
              label="Station Code"
              error={error}
              icon={<FiNavigation />}
              fullWidth
              maxLength={10}
              autoFocus
            />

            <Button
              type="submit"
              variant="secondary"
              size="lg"
              fullWidth
              isLoading={isLoading}
            >
              {isLoading ? 'Fetching Trains...' : 'Check Live Trains'}
            </Button>

            <div className={styles.hint}>
              <p>💡 Enter station code to view all upcoming trains at the station</p>
            </div>
          </form>
        </Card>

        {/* Info Section */}
        <div className={styles.infoSection}>
          <Card className={styles.infoCard}>
            <h3 className={styles.infoTitle}>Popular Station Codes</h3>
            <div className={styles.stationExamples}>
              <div className={styles.exampleItem} onClick={() => setStationCode('NDLS')}>
                <span className={styles.exampleCode}>NDLS</span>
                <span className={styles.exampleName}>New Delhi</span>
              </div>
              <div className={styles.exampleItem} onClick={() => setStationCode('BCT')}>
                <span className={styles.exampleCode}>BCT</span>
                <span className={styles.exampleName}>Mumbai Central</span>
              </div>
              <div className={styles.exampleItem} onClick={() => setStationCode('HWH')}>
                <span className={styles.exampleCode}>HWH</span>
                <span className={styles.exampleName}>Howrah Junction</span>
              </div>
              <div className={styles.exampleItem} onClick={() => setStationCode('MAS')}>
                <span className={styles.exampleCode}>MAS</span>
                <span className={styles.exampleName}>Chennai Central</span>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default LiveStationPage;